(ns loader.views
  (:require
   [reagent.core :as r]
   [very.re-frame.core :as rf]
   [cljss.core :as cljss]
   [css.form :as form]
   [main.common :as common]
   [branding.views :as branding]
   [css.typography :as typo]
   [css.core :as css
    :refer [class-names get-theme defstyled]]))

(defstyled wrapper-s :div
  {:position "fixed"
   :top "0"
   :left "0"
   :right "0"
   :bottom "0"
   :z-index 99999
   :align-items "center"
   :justify-content "center"
   :display (with-meta #(if % "none" "grid") :hidden?)})

(defstyled overlay-s :div
  {:background-color "rgba(255, 255, 255, .95)"
   :position "absolute"
   :top "0"
   :bottom "0"
   :right "0"
   :left "0"})

(defstyled loader-s :div
  {:background-image "url(/assets/loader.gif)"
   :background-repeat "no-repeat"
   :background-size "128px"
   :background-position "center"
   :width "128px"
   :height "128px"
   :position "relative"
   :margin "auto"
   :z-index "1"
   ::cljss/media {[[:max-width "768px"]]
                  {:width "96px"
                   :height "96px"
                   :background-size "96px"}}})

(defstyled global-s :div
  {:display "grid"
   :padding "2rem 1rem"
   :align-items "center"
   :justify-content "center"
   :margin "auto"})

(defn page []
  (let [status (rf/subscribe [:loader/status])]
    (fn []
      [wrapper-s {:hidden? (not @status)
                  :data-test "page-loader"}
         [overlay-s]
         [common/grid-s {:grid-gap "6rem"
                         :justify-content "center"}
          [branding/logo {:justify-content "center"}]
          [loader-s]]])))

(defn global [{:keys [error? on-continue on-retry]}]
  [wrapper-s {:data-test "global-loader"}
   (if-not error?
     [global-s
      [loader-s]
      [typo/h1 "We are fetching the latest information for your accounts"]
      [typo/text {:size "large"
                  :font-weight "300"
                  :text-align "center"} "This may take a few minutes. You will be automatically redirected once we're finished."]
      [branding/logo {:margin "6rem auto 0"}]]
     [global-s
      [typo/h1 {:margin "0 0 2.5rem"} "We were unable to fetch your latest account information."]
      [typo/text {:size "large"
                  :font-weight "300"} "Would you like to continue using the application with the most recent, but not the latest, account details?"]
      [form/button-row-s
       [form/secondary-button-s {:on-click on-continue} "Continue with older data"]
       [form/button {:on-click on-retry} "Try again"]]
      [branding/logo {:margin "6rem auto 0"}]])])
